import {FaFacebook, FaGithub, FaInstagram, FaLinkedin, FaTwitter,} from "react-icons/fa"

const social_links = [
    {
        id: 1,
        icon: <FaLinkedin className="social-icon"/>,
        url: "https://www.linkedin.com/in/rajvi-patel-m/",
    },
    {
        id: 2,
        icon: <FaGithub className="social-icon"/>,
        url: "https://github.com/rajvi-patel-22",
    },
    {
        id: 3,
        icon: <FaTwitter className="social-icon"/>,
        url: "https://x.com/rajvipatel003",
    },
    {
        id: 4,
        icon: <FaInstagram className="social-icon"/>,
        url: "https://www.instagram.com/rajvi__patel__22/",
    },
]

export default social_links
